import { createContext, useContext } from "react";

interface PreloaderContextType {
  isComplete: boolean;
}

export const PreloaderContext = createContext<PreloaderContextType>({
  isComplete: false,
});

export const usePreloader = () => useContext(PreloaderContext);
